import { AvatarImage } from '@tpct/admin-ui';

type ProfileAvatarProps = {
  src?: string;
  alt: string;
  className?: string;
};

const ProfileAvatar = ({ src, alt, className }: ProfileAvatarProps) => (
  <AvatarImage src={src} alt={alt} className={className} />
);

export default ProfileAvatar;
